<template>
    <div class="performance">
        <v-toolbar color="cyan" dark class="epmc-head">
            <v-toolbar-side-icon @click.stop="doSwitchDrawer"></v-toolbar-side-icon>
            <v-toolbar-title>{{ this.$route.meta.title }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-icon :disabled="!dayCanFill" @click.stop="save">check</v-icon>
        </v-toolbar>
        <v-content style="padding:0px 10px;">
            <v-container class="epmc-container" color="cyan" fluid fill-height>
                <v-layout column>
                        <v-flex xs12>
                            <v-flex xs12 color="cyan">
                                <v-select required color="cyan" clearable chips
                                          :items="dayOfWeekOption.data"
                                          item-text="name"
                                          item-value="index"
                                          :label="dayOfWeekOption.label"
                                          v-model="dayOfWeekOption.currentWeekOfData"
                                          @change="onChange">
                                </v-select>
                            </v-flex>
                            <v-form>
                                <v-carousel :class="{'epmc-swiper':true, 'cyan':true,'submited':!dayCanFill}"
                                            :cycle="swiperOption.cycle"
                                            hide-delimiters touchless height="75vh" @change="onCarouselChange"
                                            :value="currentToDo.index">
                                    <v-carousel-item
                                            v-for="dayOfWeek in toDoList"
                                            :key="dayOfWeek.day">
                                        <template slot-scope="">
                                            <h2 class="week-title">{{ dayOfWeek.day+'(' +
                                                format(dayOfWeek.dateValue)+')'
                                                }}</h2>
                                            <div class="week-content">
                                                <ul>
                                                    <li>
                                                        <v-layout row wrap>
                                                            <v-flex xs12>
                                                                <span style="color:white;">个人消耗</span>
                                                            </v-flex>
                                                            <v-flex xs12 style="padding-left:12px;">
                                                                <v-slider
                                                                        :readonly="!dayCanFill"
                                                                        :thumb-size="20"
                                                                        thumb-color="red"
                                                                        thumb-label="always"
                                                                        v-model="initWork"
                                                                        max="1"
                                                                        min="0"
                                                                        persistent-hint
                                                                        step="0.1"
                                                                        ticks>
                                                                </v-slider>
                                                            </v-flex>
                                                        </v-layout>
                                                    </li>
                                                    <li v-for="(todo,index) in dayOfWeek.list">
                                                        <v-layout row wrap>
                                                            <v-flex xs12 style="margin-bottom:5px;">
                                                                <span style="color:white;">{{ todo.item }}</span>
                                                            </v-flex>
                                                            <v-flex xs12 style="padding-left:12px;">
                                                                <v-slider
                                                                        :readonly="!dayCanFill"
                                                                        :thumb-size="20"
                                                                        thumb-color="red"
                                                                        thumb-label="always"
                                                                        v-model="todo.currVal"
                                                                        max="1"
                                                                        min="0"
                                                                        :rules="todoRules.rules"
                                                                        persistent-hint
                                                                        step="0.1"
                                                                        ticks
                                                                        @change="onSlideChange">
                                                                </v-slider>
                                                            </v-flex>
                                                        </v-layout>
                                                    </li>
                                                </ul>
                                            </div>
                                        </template>
                                    </v-carousel-item>
                                </v-carousel>
                            </v-form>
                        </v-flex>
                        <v-flex xs12>
                            <v-snackbar auto-height
                                        top
                                        v-model="snackbarOption.show"
                                        :color="snackbarOption.hintType"
                                        :timeout="snackbarOption.timeout">
                                {{ snackbarOption.text }}
                                <v-btn dark
                                       flat
                                       @click="snackbarOption.show = false">
                                    Close
                                </v-btn>
                            </v-snackbar>
                        </v-flex>

                    </v-layout>

                <!--其它基础组件 Start-->

                <!--其它基础组件 End-->

            </v-container>
        </v-content>
    </div>

</template>
<script>
    import {formatDig, formatDate, weeksOfYear} from '@/common/js/util';
    import moment from 'moment'
    import NProgress from 'nprogress'
    import {mapMutations} from 'vuex'

    export default {
        name: "performance",
        data() {
            return {
                userInfo: {
                    avatar: '',
                    name: ''
                },
                loading: false,
                initWork: 1,
                today: new Date().getDay(), /*今天是周几*/
                weeksOfYear: weeksOfYear,  /*当前年份的所有周*/
                dayOfWeekOption: {
                    data: [],/*可选择的周*/
                    currentWeekOfData: {},
                    currentWeek: {/*当前日期现在是第几周*/
                        index: 0,
                        value: '',
                        start: {}, /*当前周一对应的日期*/
                        end: {},/*当前周日对应的日期*/
                        area: []
                    },
                    editWeekDateArea: [],/*当前填写周对应的日期范围(周一至周日)*/
                    alert: false, /*是否显示提示日期范围*/
                    label: '请选择要填写的工作周',
                    toDoWeekIndex: -1,/*要填写的'第xx周'索引*/
                    editWeekIndex: -1,/*要填写的'周x'索引*/
                },
                todoRules: {
                    rules: [
                        v => v <= 1 || '不能超过1天'
                    ]
                },
                toDoList: [],/*每周或天需要填写的工作项*/
                currentToDo: {},
                swiperOption: {
                    cycle: false,
                },
                snackbarOption: { /*快速提示框*/
                    show: false,
                    hintType: '',
                    typeDict: ['success', 'info', 'error', 'cyan'],
                    text: ' Error ',
                    timeout: 4000,
                    typeEnum: {
                        success: '',
                        info: '',
                        error: '',
                        cyan: ''
                    },
                },
                holidays: [],
                projects: [],
                consumes: {list: [], hasReject: false},
                dayCanFill: true,
                hasSelfConsume:false
            }
        },
        methods: {
            ...mapMutations('sysAdmin', ['SET_DRAWER']),

            /*调用snack组件*/
            callSnack(type, text, timeout) {            /*调用快速提示框*/
                this.snackbarOption.hintType = type
                this.snackbarOption.show = true
                this.snackbarOption.text = text
                if (!timeout) {
                    this.snackbarOption.timeout = 4000
                } else {
                    this.snackbarOption.timeout = timeout
                }
            },
            init() {
                this.getToDoList()
                this.getCurrentCanSelectWeeks()
                this.loadCurrentWeek()
                this.loadHolidays()
                this.snackbarOption.typeEnum = {
                    success: this.snackbarOption.typeDict[0],
                    info: this.snackbarOption.typeDict[1],
                    error: this.snackbarOption.typeDict[2],
                    cyan: this.snackbarOption.typeDict[3],
                }
            },

            /*选择要填写的周事件*/
            onChange(index) {
                console.log(index)
                if (index === undefined) {
                    this.reSetWeekIndex()
                    this.dayOfWeekOption.alert = false
                    this.dayOfWeekOption.label = '请选择要填写的工作周'
                    return
                }

                this.dayOfWeekOption.label = ''
                const weekIndex = index - 1
                this.dayOfWeekOption.toDoWeekIndex = weekIndex

                this.dayOfWeekOption.currentWeekOfData = this.dayOfWeekOption.data[weekIndex]

                /**加载填写的日期范围**/
                this.fillEditWeekDateArea(weekIndex)

                if (index == 1) {
                    this.initYearOfFirstWeek()
                }

                this.onCarouselChange(0)
            },
            initYearOfFirstWeek() {
                /*如果是当前年份的第一周，需要确定第1天是在周几*/
                let now = new Date()
                let yearOfFirstDay = new Date(now.getFullYear(), 0, 1)
                let weekOfIndex = yearOfFirstDay.getDay()
                if (weekOfIndex != 1) { /*不是周一，需要确定在周几，然后把前面几天补上*/
                    if(weekOfIndex == 0){ /*0表示周日，计算时转为7*/
                        weekOfIndex = 7
                    }
                    for (let i = weekOfIndex - 1; i >= 1; i--) {
                        let date = new Date(now.getFullYear(), 0, 1)
                        date.setDate(date.getDate() + (i - weekOfIndex))
                        this.dayOfWeekOption.editWeekDateArea[i-1] = date
                    }

                    for (let j = weekOfIndex - 1; j < 7; j++) {
                        let dater = new Date(this.dayOfWeekOption.editWeekDateArea[j - 1])
                        dater.setDate(dater.getDate() + 1)
                        this.dayOfWeekOption.editWeekDateArea[j] = dater
                    }
                }
            },
            loadCurrentWeek() {
                let increase = 0
                this.dayOfWeekOption.currentWeek.area = []

                const weekIndex = this.dayOfWeekOption.currentWeek.index - 1
                if (!this.weeksOfYear) {
                    this.calcWeeks()
                }

                const thisWeek = this.weeksOfYear[weekIndex]
                let weekStartDate = new Date(thisWeek[0])

                do {
                    let t = new Date(weekStartDate)
                    t.setDate(t.getDate() + increase)
                    this.dayOfWeekOption.currentWeek.area.push(t)
                    increase++
                }
                while (increase <= 6)
            },
            fillEditWeekDateArea(weekIndex) {
                let increase = 0
                this.dayOfWeekOption.editWeekDateArea = []

                if (!this.weeksOfYear) {
                    this.calcWeeks()
                }
                const thisWeek = this.weeksOfYear[weekIndex]
                let weekStartDate = new Date(thisWeek[0])

                do {
                    let t = new Date(weekStartDate)
                    t.setDate(t.getDate() + increase)
                    this.dayOfWeekOption.editWeekDateArea.push(t)
                    increase++
                }
                while (increase <= 6)
            },
            calcToDoListDate(index) { //index：周几，从0开始到6
                if (this.dayOfWeekOption.editWeekDateArea.length > 0) {
                    const day = this.dayOfWeekOption.editWeekDateArea[index]
                    this.toDoList[index].dateValue = day
                }
            },
            reSetWeekIndex() {
                this.dayOfWeekOption.toDoWeekIndex = 0
            },
            isOverflow() {
                let toDo = this.currentToDo
                let n = 0
                toDo.list.forEach(v => {
                    n += v.currVal
                })
                n += this.initWork
                if (n > 1) {
                    return true
                }
                return false
            },
            save() {
                if (this.isOverflow()) {
                    this.callSnack(this.snackbarOption.typeEnum.error, '当天填写工时不能超过1天')
                    return
                }

                if (this.checkDayMustSubmit()) {
                    if (!this.checkFillWholeDay()) {
                        this.callSnack(this.snackbarOption.typeEnum.error, '工作日填写工时未达1天')
                        return
                    }
                }
                this.dayCanFill = false
                NProgress.start()
                this.loading = true
                let data = this.buildSubmitData()
                this.$store.dispatch("employee/createConsume", data)
                    .then(response => {
                        this.dayCanFill = true
                        this.loading = false;
                        NProgress.done();
                        if (response.data && response.data.code !== 200) {
                            this.callSnack(this.snackbarOption.typeEnum.error, response.data.message)
                        } else {
                            this.callSnack(this.snackbarOption.typeEnum.success, '提交成功')
                            this.loadUserConsumes()
                        }
                    })
            },
            onSlideChange() {
                if (!this.checkIsSelectWeek()) {
                    this.callSnack(this.snackbarOption.typeEnum.error, '请选择要填写的工作周')
                    this.getToDoList()
                    return
                }

                if (this.dayOfWeekOption.currentWeek.index == 0) {
                    this.callSnack(this.snackbarOption.typeEnum.error, '选择日期有误，请重试!')
                    this.getToDoList()
                    return
                }

                if (this.sumFill >= 1) {
                    this.initWork = 0
                } else {
                    if (this.checkDayMustSubmit()) {
                        this.initWork = 1 - this.sumFill
                    }
                }
            },
            checkFillWholeDay() {
                let toDo = this.currentToDo
                let n = 0.0
                toDo.list.forEach(v => {
                    n += v.currVal
                })
                n += this.initWork
                if (Number(n.toFixed(1)) < 1) {
                    return false
                }
                return true
            },
            checkIsSelectWeek() {   // =>   校验有没有选择要填写的周
                if (this.dayOfWeekOption.toDoWeekIndex === -1) {
                    return false
                }
                return true
            },
            calcWeeks() {  // =>    计算当前年份的所有周
                for (let i of this.weeks) {
                    this.weeksOfYear.push(i)
                }
            },
            homeAction() {  // => 跳转页面
                this.$router.push({path: 'epmc'})
            },
            getToDoList() {
                this.toDoList = [
                    {
                        day: '周一',
                        dateValue: undefined,
                        index: 0,
                        list: [],
                    },
                    {
                        day: '周二',
                        dateValue: undefined,
                        index: 1,
                        list: [],
                    },
                    {
                        day: '周三',
                        dateValue: undefined,
                        index: 2,
                        list: [],
                    },
                    {
                        day: '周四',
                        dateValue: undefined,
                        index: 3,
                        list: [],
                    },
                    {
                        day: '周五',
                        dateValue: undefined,
                        index: 4,
                        list: [],
                    },
                    {
                        day: '周六',
                        dateValue: undefined,
                        index: 5,
                        list: [],
                    },
                    {
                        day: '周日',
                        dateValue: undefined,
                        index: 6,
                        list: [],
                    }
                ]
            },
            onCarouselChange(index) {

                console.log('当前选择周' + ((index + 1) < 7 ? (index + 1).toString() : '日'))
                this.dayOfWeekOption.editWeekIndex = index
                this.initWork = 0.0

                this.calcToDoListDate(index)
            },
            format(date) {
                if (date === undefined) {
                    return
                }
                let fmt = 'yyyy-MM-dd'
                let o = {
                    "M+": date.getMonth() + 1,                 //月份
                    "d+": date.getDate(),                    //日
                    "h+": date.getHours(),                   //小时
                    "m+": date.getMinutes(),                 //分
                    "s+": date.getSeconds(),                 //秒
                    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
                    "S": date.getMilliseconds()             //毫秒
                };
                if (/(y+)/.test(fmt))
                    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
                for (let k in o)
                    if (new RegExp("(" + k + ")").test(fmt))
                        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
                return fmt;
            },
            buildSubmitData() {
                let data = { list:[],weekIndex:'' }
                let d = moment(this.currentToDo.dateValue.getTime()).format('YYYY-MM-DD')
                for (let i = 0; i < this.toDoList[this.currentToDo.index].list.length; i++) {
                    let todo = this.toDoList[this.currentToDo.index].list[i]
                    let dataItem = { }
                    dataItem.date = d
                    dataItem.val = todo.currVal
                    dataItem.projectId = todo.projectId
                    dataItem.projectName = todo.item
                    dataItem.type = 'project'
                    dataItem.status = 'confirmed'
                    data.list.push(dataItem)
                }
                if (this.initWork > 0) {
                    let dataItem = {}
                    dataItem.date = d
                    dataItem.val = this.initWork
                    dataItem.type = 'self'
                    dataItem.status = 'confirmed'
                    data.list.push(dataItem)
                }
                data.weekIndex = this.dayOfWeekOption.toDoWeekIndex + 1

                return data
            },
            getYearWeekIndex() {
                //momentjs
                let result = new moment().week()
                this.dayOfWeekOption.currentWeek.index = result
                this.dayOfWeekOption.currentWeek.value = '第' + (result < 10 ? '0' + result : result) + '周'
                return result
            },
            getCurrentCanSelectWeeks() {
                const currWeekIndex = this.getYearWeekIndex()
                for (let i = 1; i <= currWeekIndex; i++) {
                    this.dayOfWeekOption.data.push({
                        index: i,
                        name: '第' + (i < 10 ? '0' + i : i) + '周'
                    })
                }
            },
            loadHolidays() {
                this.$store.dispatch("holidayConfig/getAllConfig")
                    .then(response => {
                        this.holidays = response.data.data
                    })
            },
            checkDayMustSubmit() {
                let flag = !this.isHolidayCheck(this.currentToDo.dateValue)

                if (this.holidays && this.holidays.length > 0) {
                    let today = new Date(this.currentToDo.dateValue)
                    today.setHours(0)

                    const cfg = this.holidays.find(v => new Date(v.cfgDate).getTime() == today.getTime())
                    if (cfg && cfg.isHoliday) {
                        flag = false
                    }
                }

                return flag
            },
            isHolidayCheck(date) {
                /*周六和周日*/
                if (date.getDay() == 6 || date.getDay() == 0) {
                    return true
                }
                return false
            },
            loadUserConsumes() {
                this.hasSelfConsume = false
                if (!this.currentToDo.dateValue) {
                    return
                }

                let data = {date: moment(this.currentToDo.dateValue.getTime()).format('YYYY-MM-DD')}
                data.loadHistory = moment().isAfter(this.currentToDo.dateValue) ? true : false
                this.$store.dispatch("employee/getConsume", data)
                    .then(response => {
                        this.consumes = { list: [], hasReject: false }
                        if (response && response.data.data.list.length > 0) {
                            for (let i = 0; i < response.data.data.list.length; i++) {
                                let consume = response.data.data.list[i]

                                if (consume.type == 'self') {
                                    this.initWork = consume.val
                                    if(consume.id > 0) {
                                        this.hasSelfConsume = true
                                    }
                                } else {
                                    consume = {
                                        currVal: consume.val,
                                        item: consume.projectName,
                                        type: consume.type,
                                        projectId: consume.projectId
                                    }
                                    this.consumes.list.push(consume)
                                    this.$set(this.consumes.list, i, consume)
                                }
                            }
                        } else {
                            this.initWork = 1.0
                        }
                        this.consumes.hasReject = response.data.data.hasReject
                    })
            },
            checkDayCanFill() {
                if (this.consumes.hasReject) {
                    this.dayCanFill = true
                } else {
                    if (this.currentToDo.dateValue) {
                        debugger
                        let dateValue = new Date(this.currentToDo.dateValue)
                        dateValue.setHours(0)

                        let inCurrentWeek = this.dayOfWeekOption.currentWeek.area.findIndex(v => v.getTime() === dateValue.getTime())

                        if (!moment().isAfter(dateValue) || inCurrentWeek === -1) {
                            this.dayCanFill = false
                        }

                        if (this.consumes.list && this.consumes.list.length > 0) {
                            const hasConsume = this.consumes.list.find(v => v.currVal > 0)
                            if (hasConsume) {
                                this.dayCanFill = false
                            }
                        }
                        if(this.hasSelfConsume){
                            this.dayCanFill = false
                        }
                    }
                }
            },
            toTargetCarouselIndex() {
                this.onCarouselChange(this.todayOfWeek)
            },
            doSwitchDrawer() {
                this.drawer = true
            },

        },
        computed: {
            // ...mapGetters("sysAdmin", ["getDrawer"]),
            drawer: {
                get() {
                    return this.$store.state.sysAdmin.drawer
                },
                set(value) {
                    this.SET_DRAWER(value)
                }
            },
            dateArea() {
                return this.dayOfWeekOption.dateArea[0] + ' 至 ' + this.dayOfWeekOption.dateArea[1]
            },
            todayOfWeek() { /* 返回周一至周日的索引值：0-6为周一至周六，0为周日 */
                let index = new Date().getDay()
                //周一至周六：1-6、周日：0
                if (index == 0) {
                    return 6
                }
                if (index >= 1 && index <= 6) {
                    return index - 1
                }
            },
            toDoWithWeek() { /*第几周，日期范围*/
                if (this.dayOfWeekOption.toDoWeekIndex === -1) {
                    return ''
                }

                if (this.weeksOfYear.length == 0) {
                    this.calcWeeks()
                }

                let dayofWeekArea = this.weeksOfYear[this.dayOfWeekOption.toDoWeekIndex]
                if (dayofWeekArea === undefined) {
                    throw new DOMException('获取异常')
                }
                let start = dayofWeekArea[0],
                    end = dayofWeekArea[1];

                const info = `第${formatDig(this.dayOfWeekOption.toDoWeekIndex + 1)}周 ${formatDate(start)}-${formatDate(end)}`
                console.log(info)
                return info
            },
            sumFill() {
                const toDo = this.currentToDo
                let n = 0
                toDo.list.forEach(v => {
                    n += v.currVal
                })
                return n
            },

        },
        watch: {
            'dayOfWeekOption.toDoWeekIndex'(to, from) {
                console.log(to)
                console.log(from)
            },
            'currentToDo.list'(to, from) {
                if (to) {
                    if (this.sumFill > 1) {
                        to = from
                        this.callSnack(this.snackbarOption.typeEnum.error, '填写的日期超出1天的总工时')
                    }
                }
            },
            'currentToDo.dateValue'(to, from) {
                if (to) {
                    this.loadUserConsumes()
                }
            },
            'consumes'(to, from) {
                if (to) {
                    this.dayCanFill = true
                    this.currentToDo.list = []

                    for (let i = 0; i < this.consumes.list.length; i++) {
                        let consume = this.consumes.list[i]
                        this.currentToDo.list.push(consume)
                        this.$set(this.currentToDo.list, i, consume)
                    }

                    this.checkDayCanFill()

                    // if (!this.dayCanFill) {
                    //     this.callSnack(this.snackbarOption.typeEnum.error, '您提交的工时已审批或不在可填日期')
                    // }
                }
            },
            'dayOfWeekOption.currentWeek.index'(to, from) {
                if (to && to >= 0) {
                    this.loadCurrentWeek()
                    this.toTargetCarouselIndex()
                }
            },
            'dayOfWeekOption.editWeekIndex'(to, from) {
                let index = this.dayOfWeekOption.editWeekIndex
                if (index === -1) {
                    index = 0
                }
                if (this.toDoList) {
                    this.currentToDo = this.toDoList.find(v => v.index == index)
                }
            },
            'dayOfWeekOption.data'(to, from) {
                console.log(to)
            },
            'initWork'(to, from) {
                console.log("initWork from:" + from)
                console.log("initWork to:" + to)
            },
        },
        mounted() {
            this.init()
            this.onChange(this.dayOfWeekOption.currentWeek.index) //选中第几周
        }
    }
</script>

<style lang="scss" scoped>
    @import '../styles/vars.scss';

    .slider {
        background: rgba(191, 217, 214, 1);
    }

    .epmc-swiper {
        height: 100vh;
        top: 10px;
        width: 100%;
        /*overflow-y: scroll;*/
    }

    .epmc-save {
        position: absolute;
        bottom: 0px;
        right: 15px;
        left: 15px;
        max-width: 640px;
        width: auto;
        box-sizing: border-box;
        text-align: center;
        margin: 0px auto;
    }

    .week-title {
        padding-bottom: 10px;
        color: #fff;
        text-align: center;
        padding-top: 15px;
    }

    .week-content {
        padding: 10px 0px 100px 0px;
        overflow-y: auto;
        height: 100%;

        ul {
            padding: 0px 20px;
        }

        ul li {
            list-style-type: none;
        }
    }

    .submited {
        background: gray !important;
    }

</style>



// WEBPACK FOOTER //
// performance.vue?57d44351